import React from 'react';

const Reload = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 6.05263C2.85263 3.77895 4.62105 1 9.04211 1C13.4211 1 17 4.57895 17 9"
        stroke="#4E40EF"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M1 1.8421V6.05263H5.21053" stroke="#4E40EF" strokeWidth="2" strokeMiterlimit="10" />
      <path
        d="M17 11.9474C15.1474 14.1368 13.3789 17 8.95789 17C4.53684 17 1 13.4211 1 9.04211V9"
        stroke="#4E40EF"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M17 16.1579V11.9474H12.7894" stroke="#4E40EF" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
  );
};

export default Reload;
